import Button from '@shared/components/Button/Button';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ArrowDown } from 'assets/icons/ArrowDown.svg';
import { ReactComponent as ChevronRight } from 'assets/icons/ChevronRight.svg';

import useCollapsibleContext from '../useCollapsibleContext';

type CollapsibleToggleProps = {
  hasText?: boolean;
  arrowIconClassName?: string;
  variant?: 'default' | 'workspace';
  isActive?: boolean;
};

const CollapsibleToggle = ({
  hasText = true,
  arrowIconClassName,
  variant = 'default',
  isActive = false,
}: CollapsibleToggleProps) => {
  const { t } = useTranslation();
  const { isCollapsed, isCollapsible } = useCollapsibleContext();

  if (!isCollapsible) return null;

  if (variant === 'workspace') {
    return (
      <Button variant="textSecondary" className="group/toggle flex items-center !p-0" type="button">
        <span
          className={cx(
            'flex h-[18px] w-[18px] items-center justify-center rounded border',
            isActive
              ? 'border-gray-30 bg-gray-10'
              : 'border-transparent group-hover/toggle:border-gray-30 group-hover/toggle:bg-gray-10'
          )}
        >
          <ChevronRight
            className={cx('stroke-1.5 stroke-current transition-transform', arrowIconClassName, {
              '-rotate-90': !isCollapsed,
            })}
          />
        </span>
      </Button>
    );
  }

  return (
    <Button variant="textSecondary" className="flex items-center" type="button">
      {hasText && (
        <span className="font-medium hidden md:inline mr-2">{isCollapsed ? t('expand') : t('collapse')}</span>
      )}
      <ArrowDown
        className={cx('stroke-1.5 stroke-current transition-transform', arrowIconClassName, {
          'rotate-180': !isCollapsed,
        })}
      />
    </Button>
  );
};

export default CollapsibleToggle;
